import {
  Text,
  IconButton,
  VStack,
  HStack
} from '@chakra-ui/react';
import { FiFile, FiTrash2 } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import ScanStatusBadge from './ScanStatusBadge';

/**
 * ファイルリスト
 * @param files ファイル情報
 * @param onDelete ファイル削除関数
 * @returns ファイルリスト
 */
const FileList: React.FC<any> = ({ files, onDelete }) => {
  const { t } = useTranslation();
  return (
    <VStack mt={2} spacing={2} w="100%" maxH="400px" overflow="auto">
      {files.map((file: any) => (
        <HStack
          key={file.key}
          w="100%"
          p={3}
          borderWidth="1px"
          borderRadius="md"
          justify="space-between"
          bg="white"
        >
          <HStack spacing={3}>
            <FiFile size={20} />
            <VStack align="start" spacing={0}>
              <HStack spacing={2}>
                <Text fontSize="md">{file.fileName}</Text>
                {/* マルウェアスキャン状態（検知・スキャン中等のみ表示） */}
                <ScanStatusBadge scanStatus={file.scanStatus} />
              </HStack>
              <Text fontSize="sm" color="gray.500">
                {file.lastModified ? `${t('components.FileList.label.lastUploaded')}: ${new Date(file.lastModified).toLocaleString()}` : t('components.FileList.label.notUploaded')}
              </Text>
            </VStack>
          </HStack>

          <HStack spacing={4} align="center">
            <Text width="55px" fontSize="sm" textAlign="right" color="gray.500">
              {file.size < 1024 ? `${file.size} B` : `${Math.round(file.size / 1024)} KB`}
            </Text>
            {/* 読み取り専用ファイル（振り返りモード時の申請時ファイル・過去振り返り分）は削除不可 */}
            {!file.isReadOnly && (
              <IconButton
                aria-label="delete"
                icon={<FiTrash2 />}
                colorScheme="red"
                variant="ghost"
                onClick={() => onDelete(file)}
              />
            )}
          </HStack>
        </HStack>
      ))}
    </VStack>
  );
}

export default FileList;